import { render } from "./AnnouncementBar.vue?vue&type=template&id=07ea1d3c&scoped=true"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js"

import "./AnnouncementBar.vue?vue&type=style&index=0&id=07ea1d3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ea1d3c"]])

export default __exports__